import { Component } from '@angular/core';
import { CommonService } from "../../shared/services/common.service";

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss'
})
export class ConfirmModalComponent {
confirmModalTitle: string = "Confirm";
  confirmOkText: string = "OK";

  constructor(private common: CommonService) {}

  ngOnInit() {
    this.confirmModalTitle = this.common.confirmModalTitle;
    this.confirmOkText = this.common.confirmOkText;
  }

  confirmAction(confirmed: boolean) {
    this.common.confirmAction(confirmed);
  }
}
